module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/devotee-module/components/gallary/gallary.component.css
// module id = ./src/app/devotee-module/components/gallary/gallary.component.css
// module chunks = main